// import scene1 from "./item/scene1_HD.jpeg";
// import scene2 from "./item/scene2_HD.jpeg";
// import scene3 from "./item/scene3_HD.jpeg";
// import scene4 from "./item/scene4_HD.jpeg";

export const GAME = [
  {
    question: `Harrison Assessments là giải pháp \n đến từ quốc gia nào?`,
    answer: ['A: Việt Nam', 'B: Mỹ', 'C: Nhật Bản', 'D: Đức'],
    correctkey: 1,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 300,
      height: 250,
    },
    textSpace: 50,
    planeSpace: 55,
    sapce: 30,
    answerAspect: {
      width: 200,
      height: 15,
    },
  },
  {
    question: 'Logo của Harrison Assessments \n bao gồm những màu nào?',
    answer: [
      'A: Xanh da trời, trắng',
      'B: Xanh da trời, đen, trắng ',
      'C: Xanh da trời, xám, trắng ',
    ],
    correctkey: 2,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 300,
      height: 250,
    },
    textSpace: 50,
    planeSpace: 55,
    sapce: 40,
    answerAspect: {
      width: 200,
      height: 15,
    },
  },
   {
    question:
      'Harrison Assessments giúp doanh nghiệp giải quyết những bài toán nào?',
    answer: [
      'A: Giảm chi phí và rủi ro tuyển dụng bằng cách xác định \n những ứng viên lý tưởng sẽ đảm nhận xuất sắc vị trí công việc',
      'B: Thúc đẩy phát triển nhân tài với các kế hoạch phát triển \n được cá nhân hóa theo thế mạnh của từng nhân sự',
      'C: Trao quyền cho các nhà lãnh đạo với những thông tin hữu ích \n về chân dung nhóm để quản lý và thúc đẩy hiệu quả đội nhóm',
      'D: Cải thiện tỷ lệ giữ chân nhân viên bằng cách xác định và giải \n quyết các yếu tố gắn kết nhằm xây dựng đội ngũ nhân viên tinh nhuệ',
      'E: Tất cả các đáp án trên',
    ],
    correctkey: 4,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 500,
      height: 400,
    },
    textSpace: 100,
    planeSpace: 95,
    sapce: 65,
    answerAspect: {
      width: 480,
      height: 45,
    },
   },
  {
    question:
      'Harrsion Assessments được kết hợp dựa trên AI \n và Tâm lý học Nghề nghiệp - Tổ chức \n(Industrial and Organizational Psychology),\n đúng hay sai? ',
    answer: ['A: Đúng', 'B: Sai'],
    correctkey: 0,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 350,
      height: 220,
    },
    textSpace: 20,
    planeSpace: 25,
    sapce: 35,
    answerAspect: {
      width: 300,
      height: 15,
    },
  },
  {
    question: 'Câu hỏi khảo sát của Harrison được trình bày dưới dạng nào? ',
    answer: [
      'A: Dạng câu hỏi Yes/No ',
      'B: Dạng câu hỏi Rating (Cho điểm) ',
      'C: Dạng câu hỏi Ranking (Xếp hạng) ',
    ],
    correctkey: 2,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 400,
      height: 230,
    },
    textSpace: 30,
    planeSpace: 35,
    sapce: 45,
    answerAspect: {
      width: 370,
      height: 15,
    },
  },
  {
    question: 'Thời lượng hoàn thành 1 bài khảo sát Harrison Assessments: ',
    answer: ['A: 15 phút ', 'B: 25 phút ', 'C: 45 phút '],
    correctkey: 1,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 400,
      height: 200,
    },
    textSpace: 20,
    planeSpace: 25,
    sapce: 35,
    answerAspect: {
      width: 370,
      height: 15,
    },
  },
  {
    question:
      'Để nhận về hơn 20 kết quả đánh giá chuyên sâu, \n bạn cần làm bao nhiêu bài khảo sát (bảng câu hỏi) ',
    answer: ['A: 3 bài  ', 'B: 2 bài  ', 'C: 1 bài duy nhất '],
    correctkey: 2,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 400,
      height: 200,
    },
    textSpace: 30,
    planeSpace: 35,
    sapce: 35,
    answerAspect: {
      width: 320,
      height: 15,
    },
  },
  {
    question:
      'Harrison Assessments có đo lường mức độ đáng tin cậy \n của câu trả lời của người được đánh giá không?',
    answer: ['A: Có  ', 'B: Không  '],
    correctkey: 0,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 400,
      height: 200,
    },
    textSpace: 30,
    planeSpace: 35,
    sapce: 45,
    answerAspect: {
      width: 320,
      height: 15,
    },
  },
  {
    question:
      'Harrison Assessments có sẵn bao nhiêu Công thức \n thành công trong công việc?',
    answer: ['A: 650', 'B: 700', 'C: 6500', 'B: 7000'],
    correctkey: 2,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 400,
      height: 220,
    },
    textSpace: 30,
    planeSpace: 35,
    sapce: 35,
    answerAspect: {
      width: 320,
      height: 15,
    },
  },
  {
    question:
      'Công thức thành công trong công việc của \n Harrison Assessments có thể tùy chỉnh được hay không?',
    answer: ['A: Có', 'B: Không'],
    correctkey: 0,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 400,
      height: 200,
    },
    textSpace: 30,
    planeSpace: 35,
    sapce: 45,
    answerAspect: {
      width: 350,
      height: 15,
    },
  },
  {
    question:
      'Harrison Assessments đo lường \n bao nhiêu yếu tố môi trường làm việc?',
    answer: ['A: 40', 'B: 80', 'C: 175', 'D: 200'],
    correctkey: 2,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 300,
      height: 250,
    },
    textSpace: 50,
    planeSpace: 55,
    sapce: 35,
    answerAspect: {
      width: 250,
      height: 15,
    },
  },
  {
    question:
      'Lựa chọn những công nghệ, lý thuyết tiên tiến \n mà Harrison Assessments KHÔNG áp dụng',
    answer: [
      'A: Công nghệ Nghịch lý (Paradox)',
      'B: Bảng câu hỏi thông minh trong 25 phút',
      'C: Công nghệ phép đo lưỡng cực (truyền thống)',
      'D: Lý thuyết hiệu suất và sự yêu thích công việc',
    ],
    correctkey: 2,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 470,
      height: 350,
    },
    textSpace: 100,
    planeSpace: 105,
    sapce: 50,
    answerAspect: {
      width: 450,
      height: 35,
    },
  },
  {
    question:
      'Kết quả đánh giá “Cặp đặc điểm đối lập - Nghịch lý (Paradox)” \n đo lường bao nhiêu cặp đặc điểm đối lập, chia ra thành các nhóm nào?',
    answer: [
      'A: 12 cặp chia ra 3 nhóm: Giao tiếp, Thành tích, Lãnh đạo',
      'B: 24 cặp, chia ra 4 nhóm: Khởi đầu, Động lực, Thực hiện, Duy trì',
    ],
    correctkey: 0,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 470,
      height: 220,
    },
    textSpace: 30,
    planeSpace: 35,
    sapce: 45,
    answerAspect: {
      width: 430,
      height: 15,
    },
  },
  {
    question:
      'Nhóm các “Cặp đặc điểm đối lập - Nghịch lý (Paradox) - Lãnh đạo” \n bao gồm 4 cặp nào?',
    answer: [
      'A: Quản lý cơ hội, Tư duy huấn luyện hiệu suất,\n Trách nhiệm với tập thể, Kiên cường thận trọng',
      'B: Bản năng suy luận, Kết quả bền vững, Cải tiến,\n Khả năng thích nghi',
      'C: Củng cố kết luận, Tự nhận thức về bản thân,\n Thẳng thắn tôn trọng, Tư duy công bằng',
    ],
    correctkey: 0,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 470,
      height: 300,
    },
    textSpace: 70,
    planeSpace: 75,
    sapce: 65,
    answerAspect: {
      width: 430,
      height: 60,
    },
  },
  {
    question:
      'Harrison có cung cấp kết quả đánh giá\n “Gắn kết & Kỳ vọng việc làm” bao gồm 8 kỳ vọng, đúng hay sai?',
    answer: ['A: Đúng', 'B: Sai'],
    correctkey: 0,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 450,
      height: 200,
    },
    textSpace: 30,
    planeSpace: 35,
    sapce: 40,
    answerAspect: {
      width: 390,
      height: 15,
    },
  },
  {
    question:
      'Success Software Services là nhà phân phối giải pháp\n Harrison Assessments tại thị trường Việt Nam từ năm 2020, đúng hay sai?',
    answer: ['A: Đúng', 'B: Sai'],
    correctkey: 0,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 470,
      height: 190,
    },
    textSpace: 10,
    planeSpace: 15,
    sapce: 40,
    answerAspect: {
      width: 450,
      height: 15,
    },
  },
  /////////////////////////////////
  {
    question:
      'Các khách hàng tiêu biểu của Success Software Services tại Việt Nam:',
    answer: [
      'A: Amway Việt Nam',
      'B: Saint-Gobain Việt Nam',
      'C: KTG',
      'D: Đại Đồng Tiến',
      'E: Gein Academy',
      'F: Tất cả các đáp án trên',
    ],
    correctkey: 5,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 470,
      height: 350,
    },
    textSpace: 100,
    planeSpace: 105,
    sapce: 50,
    answerAspect: {
      width: 450,
      height: 35,
    },
  },
  {
    question:
      'Bộ giải pháp Chuyển đổi số của Success Software Services cung cấp bao gồm:',
    answer: [
      'A: Đánh giá & tư vấn chuyển đổi số',
      'B: Đánh giá nguồn nhân lực (Harrison Assessments)',
      'C: Quản trị thông tin thông minh (Power BI',
      'D: Công nghệ thực tế ảo VR 360',
      'E: Đánh giá bảo mật thông tin',
      'F: Tất cả các đáp án trên',
    ],
    correctkey: 5,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 470,
      height: 350,
    },
    textSpace: 100,
    planeSpace: 105,
    sapce: 50,
    answerAspect: {
      width: 450,
      height: 35,
    },
  },
  {
    question:
      'Khách hàng của Success Software Services đến từ bao nhiêu quốc gia?',
    answer: ['A. 4', 'B. 12', 'C. 20', 'D.15'],
    correctkey: 1,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 470,
      height: 350,
    },
    textSpace: 100,
    planeSpace: 105,
    sapce: 50,
    answerAspect: {
      width: 450,
      height: 35,
    },
  },
  {
    question:
      'Success Software Services là công ty thành viên của Tập đoàn Nihonkikaku Nhật Bản,\n với quy mô hơn 1.000 nhân sự và có trụ sở văn phòng tại Việt Nam, Canada cùng 5 văn phòng tại Nhật Bản.\n Đúng hay sai?',
    answer: ['A: Đúng', 'B: Sai'],
    correctkey: 0,
    titleSize: 1,
    textSize: 1,
    aspect: {
      width: 700,
      height: 250,
    },
    textSpace: 30,
    planeSpace: 35,
    sapce: 45,
    answerAspect: {
      width: 650,
      height: 15,
    },
  },
];

export const GIFT_DATA = {
  position: [
    {
      x: 230.39704783440487,
      y: 224.1994001229678,
      z: 382.3868884627508,
    },
    {
      x: -470.9450054425138,
      y: -31.045853816110316,
      z: -163.04921853541202,
    },
    {
      x: 447.27747325179513,
      y: -93.82837754103463,
      z: -201.6325011855058,
    },
    {
      x: 82.19388582497143,
      y: 439.7454701655682,
      z: -222.25797523340756,
    },
    {
      x: 1.9085643651340385,
      y: 216.72339356156485,
      z: 450.13863093362573,
    },
    {
      x: 152.09950395043148,
      y: -311.48835000161,
      z: -359.47005717646266,
    },
    {
      x: -411.4284466570045,
      y: -210.51230591847644,
      z: 189.20134473179337,
    },
  ],
};

// export const DATA = [
//   {
//     imgUrl: scene1,
//     name: "scene 1",
//     hotspot: [
//       {
//         position: [102.82052762968334, -78.2436488525845, 889.9663736586673],
//         toScene: 1,
//       },
//     ],
//     media: [
//       {
//         position: [-201.63058810302138, 35.192607259272656, 455.9607224930605],
//         title: `Máy in phun công nghiệp tự động`,
//         dsc: "hello hello hello hello",
//         aspect: { x: 250, y: 30 },
//         scale: 1,
//       },
//       {
//         position: [
//           102.59589290631854, -11.370679022385074, -488.83748977634224,
//         ],
//         title: "Máy jurmet advancer",
//         dsc: "hello hello hello hello",
//         aspect: { x: 250, y: 30 },
//         scale: 1,
//       },
//     ],
//     giflPercent: 0,
//   },
//   {
//     imgUrl: scene2,
//     name: "scene 2",
//     hotspot: [
//       {
//         position: [-846.3988829564494, -64.04600883554077, 295.9869325630788],
//         toScene: 2,
//       },
//     ],
//     media: [
//       {
//         position: [332.1843291364976, -50.89479576169587, 369.7457102503907],
//         title: "Khu vực làm việc",
//         dsc: "hello hello hello hello",
//         aspect: { x: 150, y: 30 },
//         scale: 1,
//       },
//       {
//         position: [-395.1995075857016, -41.82710954367951, 302.45456903588433],
//         title: "Máy in công nghiệp",
//         dsc: "hello hello hello hello",
//         aspect: { x: 150, y: 30 },
//         scale: 1,
//       },
//     ],
//     giflPos: [],
//     giflPercent: 0.75,
//   },
//   {
//     imgUrl: scene3,
//     name: "scene 3",
//     hotspot: [
//       {
//         position: [856.9278296155084, -214.88734871247027, 167.53252618327207],
//         toScene: 3,
//       },
//     ],
//     media: [
//       {
//         position: [
//           -241.58254893353788, -118.4222400304082, -421.28065071073445,
//         ],
//         title: "Khu vực làm việc",
//         dsc: "hello hello hello hello",
//         aspect: { x: 150, y: 30 },
//         scale: 1,
//       },
//       {
//         position: [-311.6102454693325, -35.51708807638568, 388.36787443628856],
//         title: "Máy in công nghiệp",
//         dsc: "hello hello hello hello",
//         aspect: { x: 150, y: 30 },
//         scale: 1,
//       },
//     ],
//     giflPercent: 0.75,
//   },
//   {
//     imgUrl: scene4,
//     name: "scene 4",
//     hotspot: [
//       {
//         position: [877.7603712911181, -191.15936831541848, 21.757259002674914],
//         toScene: 0,
//       },
//     ],
//     giflPercent: 0.75,
//   },
// ];
